import PropTypes from "prop-types"
import React, { useEffect, useState, Suspense, useMemo } from "react"
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Import scss
import "./assets/scss/theme.scss"
import "./custom.css"
import "./global.css"
import LoaderSvg from "assets/images/loader-icon.gif"
import { useSelector } from "react-redux"
import { Routes, Route, Outlet } from "react-router-dom"
import { layoutTypes } from "./constants/layout"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"
import SweatAlert from "components/Shared/SweatAlert"
import ErrorBoundary from "components/Shared/ErrorBoundary"

// Import all middleware
import Authmiddleware from "./routes/route"
import { OnboardingProvider } from "context/OnboardingContext"
import { PortalTenantProvider } from "context/PortalTenantContext"

dayjs.extend(utc);
dayjs.extend(timezone);
// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
// Eager: lazy NonAuthLayout suspends on sync navigations (e.g. Logout click) → React #426
import NonAuthLayout from "./components/NonAuthLayout"
import GuestRoute from "./components/GuestRoute"
import Spinners from "components/Shared/Spinners"

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const AuthenticatedLayout = () => {
  const layoutType = useSelector(state => state.Layout.layoutType)
  const LayoutComponent = useMemo(() => getLayout(layoutType), [layoutType])

  return (
    <Authmiddleware>
      <LayoutComponent key={layoutType}>
        <Outlet />
      </LayoutComponent>
    </Authmiddleware>
  )
}

const App = ({ router }) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const { isVisible, text, type } = useSelector(state => state.Alert)

  useEffect(() => {
    const splashScreenInterval = setInterval(() => {
      const navState = router.state.navigation.state
      if (navState == "idle") {
        // Hide the splash screen.
        setShowSplashScreen(false)
        clearInterval(splashScreenInterval)
      }
    }, 3000)

    // cleanup in case of component unmount
    ;() => clearInterval(splashScreenInterval)
  }, [])

  return (
    <React.Fragment>
      <ErrorBoundary>
        <>
          {/* {showSplashScreen ? (
            <Suspense fallback={<Spinners />}>
              <Spinners />
            </Suspense>
          ) : ( */}
          <Suspense fallback={<Spinners />}>
            {isVisible ? <SweatAlert text={text} type={type} /> : null}
            <PortalTenantProvider>
            <OnboardingProvider>
            <Routes>
              {publicRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <NonAuthLayout>
                      <GuestRoute>{route.component}</GuestRoute>
                    </NonAuthLayout>
                  }
                  key={idx}
                  exact={true}
                />
              ))}

              <Route element={<AuthenticatedLayout />}>
                {authProtectedRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={route.component}
                    key={idx}
                    exact={true}
                  />
                ))}
              </Route>
            </Routes>
            </OnboardingProvider>
            </PortalTenantProvider>
          </Suspense>
          {/* )} */}
        </>
      </ErrorBoundary>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
